__turbopack_context__.v({
  "description": "PageSection-module__KWlMda__description",
  "left": "PageSection-module__KWlMda__left",
  "right": "PageSection-module__KWlMda__right",
  "root": "PageSection-module__KWlMda__root",
  "title": "PageSection-module__KWlMda__title",
});
